<div [ngStyle]="{ 'display' : calculationsService.calcConfigInfoActive? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
    <div class="fields__block" style="width: 100%; overflow: scroll; height: 450px;" *ngIf="calculationsService.calcInfo">

      <div  *ngIf="!calculationsService.calculationInfoIsString" class="fields__block__section">
            <h4><strong>Calculation Configuration:</strong> {{calculationsService.calcInfo.id}}</h4>
            <div *ngIf="!isInstance(NAVAID_SITING_TOOL)" >
                <label class="text-bold text-gray mb-1 text-decoration">Environment Options:</label>
                <ul class="list-style">
                    <li class="mb-1 text-sm">
                        Project: <span class="text-italic">{{projectService.activeProject.name}}</span>
                    </li>
                    <li class="mb-1 text-sm">
                        Configuration: <span class="text-italic">{{configService.currentConfiguration.name}}</span>
                    </li>
                </ul>
            </div>
            <ng-container *ngIf="isInstance(COVERAGE) || isInstance(CUMULATIVE_COVERAGE)">
                <div *ngIf="getDTO().isCoverageAssessmentTool">
                    <label class="text-bold text-gray mb-1 text-decoration">Coverage Assessment Tool Options:</label>
                    <ul class="list-style">
                        <li class="mb-1 text-sm">
                            Propagation Type: <span class="text-italic">{{PROPAGATION_TYPE_OPTIONS[getDTO().propagationType]}}</span>
                        </li>
                        <li class="mb-1 text-sm">
                            Range Limitation Type: <span class="text-italic">{{getDTO().rangeLimitation}}</span>
                        </li>
                        <li class="mb-1 text-sm" *ngIf="isInstance(COVERAGE)">
                            Calculation Type: <span class="text-italic">Coverage</span>
                        </li>
                        <li class="mb-1 text-sm" *ngIf="!isInstance(COVERAGE)">
                            Calculation Type: <span class="text-italic">Cumulative Coverage</span>
                        </li>
                        <li class="mb-1 text-sm">
                            Coverage Algorithm Type: <span class="text-italic">{{getDTO().calculationSettings.algorithm}}</span>
                        </li>
                    </ul>
                </div>
            </ng-container>
            <ng-container *ngIf="isInstance(COVERAGE) || isInstance(CUMULATIVE_COVERAGE) || isInstance(DOC_AND_SEC) ||
            isInstance(IMPACT_ASSESSMENT)">
                <div>
                    <ng-container *ngIf="isInstance(COVERAGE) || isInstance(DOC_AND_SEC) || isInstance(IMPACT_ASSESSMENT)">
                        <label class="text-bold text-gray mb-1 text-decoration">Coverage Options:</label>
                        <ul class="list-style">
                            <li class="mb-1 text-sm">
                                Min Altitude: <span class="text-italic">{{getDTO().minAltitude * 100}}</span>
                            </li>
                            <li class="mb-1 text-sm">
                                Max Altitude: <span class="text-italic">{{getDTO().maxAltitude * 100}}</span>
                            </li>
                        </ul>
                    </ng-container>
                    <ng-container *ngIf="isInstance(CUMULATIVE_COVERAGE)">
                        <label class="text-bold text-gray mb-1 text-decoration">Cumulative Coverage Options:</label>
                        <ul class="list-style">
                            <li class="mb-1 text-sm" *ngIf="getDTO().minAltitude == getDTO().maxAltitude">
                                Altitude: <span class="text-italic">{{getDTO().maxAltitude * 100}}</span>
                            </li>
                            <li class="mb-1 text-sm" *ngIf="getDTO().minAltitude != getDTO().maxAltitude">
                                Min Altitude: <span class="text-italic">{{getDTO().minAltitude * 100}}</span>
                            </li>
                            <li class="mb-1 text-sm" *ngIf="getDTO().minAltitude != getDTO().maxAltitude">
                                Max Altitude: <span class="text-italic">{{getDTO().maxAltitude * 100}}</span>
                            </li>
                            <li class="mb-1 text-sm" *ngIf="getDTO().minAltitude != getDTO().maxAltitude">
                                Feet Interval: <span class="text-italic">{{getDTO().altitudeInterval * 100}}</span>
                            </li>
                            <li class="mb-1 text-sm">
                                Scaling Factor: <span class="text-italic">{{VISIBILITY_SCALING_OPTIONS[parseInt(getDTO().calculationSettings.visibilityScaling)]}}</span>
                            </li>
                        </ul>
                    </ng-container>
                    <label class="text-bold text-gray mb-1 text-decoration">Feet Interval:</label>
                    <ul class="list-style">
                        <li class="mb-1 text-sm">
                            Feet Interval Value: <span class="text-italic">{{getDTO().altitudeInterval * 100}}</span>
                        </li>
                    </ul>
                    <label class="text-bold text-gray mb-1 text-decoration">Range limitation:</label>
                    <ul class="list-style">
                        <li class="mb-1 text-sm" *ngIf="!isInstance(IMPACT_ASSESSMENT)">
                            Range limitation type:
                            <span class="text-italic" *ngIf=" getDTO().useFSPL">Free Space Path Loss</span>
                            <span class="text-italic" *ngIf="!getDTO().useFSPL && getDTO().rangeLimitation != 'NoLimit'">DOC</span>
                            <span class="text-italic" *ngIf="!getDTO().useFSPL && getDTO().rangeLimitation == 'NoLimit'">Radio Horizon</span>
                        </li>

                        <li class="mb-1 text-sm" *ngIf="isInstance(IMPACT_ASSESSMENT)">
                          Range limitation type:
                          <span class="text-italic">Free Space Path Loss</span>
                        </li>
                    </ul>
                </div>
            </ng-container>
            <div *ngIf="isInstance(PERFORMANCE)">
                <label class="text-bold text-gray mb-1 text-decoration">Performance Options:</label>
                <ul class="list-style">
                    <li class="mb-1 text-sm" *ngIf="getDTO().flightLevel">
                        Altitude: <span class="text-italic">{{getDTO().flightLevel * 100}}</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="!getDTO().flightLevel">
                        Min Altitude: <span class="text-italic">{{getDTO().minAltitude * 100}}</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="!getDTO().flightLevel">
                        Max Altitude: <span class="text-italic">{{getDTO().maxAltitude * 100}}</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="!getDTO().flightLevel">
                        Feet Interval: <span class="text-italic">{{getDTO().altitudeInterval * 100}}</span>
                    </li>
                    <li class="mb-1 text-sm">
                        Subtended Angle: <span class="text-italic">{{SUBTENDED_ANGLE_OPTIONS[parseInt(getDTO().rnav.subtendedAngleRange)]}}</span>
                    </li>
                    <li class="mb-1 text-sm">
                        Calculation Type: <span class="text-italic">{{CALCULATION_TYPE_OPTIONS[getDTO().calculationType]}}</span>
                    </li>
                </ul>
            </div>
            <div *ngIf="isInstance(TERRAIN_ALTITUDE_CUT)">
                <label class="text-bold text-gray mb-1 text-decoration">Terrain Altitude Cut Options:</label>
                <ul class="list-style">
                    <li class="mb-1 text-sm" *ngIf="getDTO().flightLevel">
                        Altitude: <span class="text-italic">{{getDTO().altitudeFT}}</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="getDTO().flightLevel">
                        Scaling Factor: <span class="text-italic">{{VISIBILITY_SCALING_OPTIONS[parseInt(getDTO().calculationSettings.visibilityScaling)]}}</span>
                    </li>
                </ul>
            </div>
            <div *ngIf="!isInstance(TERRAIN_ALTITUDE_CUT) && !isInstance(NAVAID_SITING_TOOL) && !isInstance(IMPACT_ASSESSMENT)">
                <label class="text-bold text-gray mb-1 text-decoration">Rnav Config:</label>
                <ul class="list-style">
                    <li class="mb-1 text-sm" *ngIf="isInstance(PERFORMANCE)">
                        Signal In Space Error Budget: <span class="text-italic">{{getDTO().rnav.signalInSpaceErrorBudget}}</span>
                    </li>
                    <li class="mb-1 text-sm">
                        Min Facility DME: <span class="text-italic">{{getDTO().rnav.minDmeFacilityRange}}</span>
                    </li>
                    <li class="mb-1 text-sm">
                        Max Facility DME: <span class="text-italic">{{getDTO().rnav.maxDmeFacilityRange}}</span>
                    </li>
                    <li class="mb-1 text-sm">
                        Max Elevation Angle: <span class="text-italic">{{getDTO().rnav.maxElevationAngle}}</span>
                    </li>
                </ul>
            </div>
            <div *ngIf="!isInstance(NAVAID_SITING_TOOL)">
                <label class="text-bold text-gray mb-1 text-decoration">General Config:</label>
                <ul class="list-style">
                    <li class="mb-1 text-sm">
                        Max System Altitude: <span class="text-italic">{{getDTO().calculationSettings.maxSystemAltitude}}</span>
                    </li>
                    <li class="mb-1 text-sm">
                        Min System Altitude: <span class="text-italic">{{getDTO().calculationSettings.minSystemAltitude}}</span>
                    </li>
                    <li class="mb-1 text-sm">
                        Refraction CoefficientK: <span class="text-italic">{{getDTO().calculationSettings.kfactor}}</span>
                    </li>
                </ul>
            </div>
            <div *ngIf="!isInstance(NAVAID_SITING_TOOL)">
                <label class="text-bold text-gray mb-1 text-decoration">Calculation Config:</label>
                <ul class="list-style">
                    <li class="mb-1 text-sm">
                        Azimuth Increment: <span class="text-italic">{{AZIMUTH_OPTIONS[getDTO().calculationSettings.azimuthIncrement]}}</span>
                    </li>
                    <li class="mb-1 text-sm">
                        Summit Granularity: <span class="text-italic">{{getDTO().calculationSettings.summitGranularity}}</span>
                    </li>
                    <li class="mb-1 text-sm">
                        Sector Length: <span class="text-italic">{{SECTOR_LENGTH_OPTIONS[getDTO().calculationSettings.sectorLength]}}</span>
                    </li>
                    <li class="mb-1 text-sm">
                        Visibility Granularity: <span class="text-italic">{{VISIBILITY_GRANULARITY_OPTIONS[getDTO().calculationSettings.visibilityGranularity]}}</span>
                    </li>
                    <li class="mb-1 text-sm">
                        Automatically Fill Terrain Voids: <span class="text-italic">{{getDTO().calculationSettings.autoFillTerrainVoids}}</span>
                    </li>
                    <li class="mb-1 text-sm">
                        Facility Elevation: <span class="text-italic">{{FACILITY_ELEVATION_OPTIONS[getDTO().calculationSettings.elevationType]}} Elevation</span>
                    </li>
                    <li class="mb-1 text-sm">
                        Sector Cell Height: <span class="text-italic">Consider Maximum Terrain Height</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="!isInstance(TERRAIN_ALTITUDE_CUT)">
                        Use Cone Of Silence: <span class="text-italic">{{getDTO().calculationSettings.useConeOfSilence}}</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="!isInstance(TERRAIN_ALTITUDE_CUT)">
                        Use DOC: <span class="text-italic">{{getDTO().rangeLimitation != 'NoLimit'}}</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="!isInstance(TERRAIN_ALTITUDE_CUT)">
                        Use Sectorization: <span class="text-italic">{{getDTO().calculationSettings.useSectorization}}</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="!isInstance(TERRAIN_ALTITUDE_CUT) && isInstance(PROCEDURE_ANALYSIS)">
                        Consider receiver delay: <span class="text-italic">{{getDTO().receiverDelay}}</span>
                    </li>
                </ul>
            </div>
            <div *ngIf="(isInstance(COVERAGE) || isInstance(CUMULATIVE_COVERAGE)) && !getDTO().isCoverageAssessmentTool">
                <label class="text-bold text-gray mb-1 text-decoration">Coverage Calculation:</label>
                <ul class="list-style">
                    <li class="mb-1 text-sm">
                        Algorithm: <span class="text-italic">{{COVERAGE_ALGORITHM_OPTIONS[parseInt(getDTO().calculationSettings.algorithm)]}}</span>
                    </li>
                </ul>
            </div>
            <div *ngIf="!isInstance(NAVAID_SITING_TOOL)">
                <label class="text-bold text-gray mb-1 text-decoration">Terrain Config:</label>

                <ul class="list-style" *ngFor="let terrain of getTerrainsOfType('GTOPO30')">
                    <li class="mb-1 text-sm" *ngIf="terrain.active">
                        GTOPO30: <span class="text-italic">{{terrain.name}} - Active</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="!terrain.active">
                        GTOPO30: <span class="text-italic">{{terrain.name}} - Disable</span>
                    </li>
                </ul>
                <ul class="list-style" *ngFor="let terrain of getTerrainsOfType('DTED0')">
                    <li class="mb-1 text-sm" *ngIf="terrain.active">
                        DTED0: <span class="text-italic">{{terrain.name}} - Active</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="!terrain.active">
                        DTED0: <span class="text-italic">{{terrain.name}} - Disable</span>
                    </li>
                </ul>

                <ul class="list-style" *ngFor="let terrain of getTerrainsOfType('DTED1')">
                    <li class="mb-1 text-sm" *ngIf="terrain.active">
                        DTED1: <span class="text-italic">{{terrain.name}} - Active</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="!terrain.active">
                        DTED1: <span class="text-italic">{{terrain.name}} - Disable</span>
                    </li>
                </ul>

                <ul class="list-style" *ngFor="let terrain of getTerrainsOfType('DTED2')">
                    <li class="mb-1 text-sm" *ngIf="terrain.active">
                        DTED2: <span class="text-italic">{{terrain.name}} - Active</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="!terrain.active">
                        DTED2: <span class="text-italic">{{terrain.name}} - Disable</span>
                    </li>
                </ul>

                <ul class="list-style" *ngFor="let terrain of getTerrainsOfType('SRTM')">
                    <li class="mb-1 text-sm" *ngIf="terrain.active">
                        SRTM: <span class="text-italic">{{terrain.name}} - Active</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="!terrain.active">
                        SRTM: <span class="text-italic">{{terrain.name}} - Disable</span>
                    </li>
                </ul>

                <ul class="list-style" *ngFor="let terrain of getTerrainsOfType('GeoTiff')">
                    <li class="mb-1 text-sm" *ngIf="terrain.active">
                        GeoTiff: <span class="text-italic">{{terrain.name}} - Active</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="!terrain.active">
                        GeoTiff: <span class="text-italic">{{terrain.name}} - Disable</span>
                    </li>
                </ul>

                <ul class="list-style" *ngFor="let terrain of getTerrainsOfType('ASCII')">
                    <li class="mb-1 text-sm" *ngIf="terrain.active">
                        ASCII: <span class="text-italic">{{terrain.name}} - Active</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="!terrain.active">
                        ASCII: <span class="text-italic">{{terrain.name}} - Disable</span>
                    </li>
                </ul>

                <ul class="list-style" *ngFor="let terrain of getTerrainsOfType('ArcGrid')">
                    <li class="mb-1 text-sm" *ngIf="terrain.active">
                        ArcGrid: <span class="text-italic">{{terrain.name}} - Active</span>
                    </li>
                    <li class="mb-1 text-sm" *ngIf="!terrain.active">
                        ArcGrid: <span class="text-italic">{{terrain.name}} - Disable</span>
                    </li>
                </ul>

            </div>
            <div *ngIf="isInstance(NAVAID_SITING_TOOL)">
                <label class="text-bold text-gray mb-1 text-decoration">Minimum Subtended Angle and DOC:</label>
                <ul class="list-style">
                    <li class="mb-1 text-sm">
                        Minimum Subtended Angle Value: <span class="text-italic">{{this.calculationsService.calcInfo.minSubAngle}}</span>
                    </li>
                    <li class="mb-1 text-sm">
                        DOC Value: <span class="text-italic">{{this.calculationsService.calcInfo.docVal}}</span>
                    </li>
                </ul>
            </div>
            <div *ngIf="!isInstance(TERRAIN_ALTITUDE_CUT) && !isInstance(IMPACT_ASSESSMENT)">

                <ng-container *ngFor="let nav of this.calculationsService.calcInfo.navAidList">
                    <label class="text-bold text-gray mb-1 text-decoration">NavAid (id: {{nav.navaidId}})</label>
                    <ul class="list-style">
                        <li class="mb-1 text-sm">
                            name: <span class="text-italic">{{nav.name}}</span>
                        </li>
                        <li class="mb-1 text-sm">
                            type: <span class="text-italic">{{nav.type}}</span>
                        </li>
                        <li class="mb-1 text-sm">
                            Icao Country code: <span class="text-italic">{{nav.icaocc}}</span>
                        </li>
                    </ul>
                </ng-container>

                <ng-container *ngIf="isInstance(NAVAID_SITING_TOOL)">
                    <label class="text-bold text-gray mb-1 text-decoration">Visibility and Flight Level:</label>
                    <ul class="list-style">
                        <li class="mb-1 text-sm">
                            Use Visibility Value: <span class="text-italic">{{this.calculationsService.calcInfo.isToUseVisibility}}</span>
                        </li>
                        <li class="mb-1 text-sm" *ngIf="this.calculationsService.calcInfo.isToUseVisibility">
                            Flight Level Value: <span class="text-italic">{{this.calculationsService.calcInfo.flightLevel}}</span>
                        </li>
                    </ul>
                </ng-container>
            </div>

            <div *ngIf="isInstance(IMPACT_ASSESSMENT)">


              <ng-container *ngFor="let device of getDTO().devices">
                <label class="text-bold text-gray mb-1 text-decoration">RFI-Transmitter: {{device.name.split("-")[0]}} </label>
                <label class="text-bold text-gray mb-1 text-decoration">| Receiver: {{device.name.split("-")[1]}}</label>
                <ul class="list-style">
                  <li class="mb-1 text-sm text-bold">RFI-Transmitter Type: {{device.type.split("-")[0]}}</li>
                  <li class="mb-1 text-sm">RFI-Transmitter Height [m]: {{device.effectiveHeight}}</li>
                  <li class="mb-1 text-sm">RFI-Transmitter Frequency [GHz]: {{device.frequency / 1000000000}}</li>
                  <li class="mb-1 text-sm">RFI-Transmitter Power [dbW]: {{device.devicePower}}</li>
                  <li class="mb-1 text-sm">RFI-Transmitter Gain [dbi]: {{device.deviceGain}}</li>
                  <li class="mb-1 text-sm">RFI-Transmitter Maximum Potential Range [NM]: {{device.range}}</li>
                  <li class="mb-1 text-sm">RFI-Transmitter Antenna Polarisation: {{device.antennaPolarisation}}</li>
                  <li class="mb-1 text-sm text-bold">Receiver Type: {{device.type.split("-")[1]}}</li>
                  <li class="mb-1 text-sm">Receiver Power [dbW]: {{device.receiverPower}}</li>
                  <li class="mb-1 text-sm">Receiver Gain [dbi]: {{device.receiverGain}}</li>

                  <ng-container *ngIf="device.sectorizations?.length > 0">
                    <label class="text-bold text-gray mb-1 text-decoration">Sectorizations</label>
                    <ul class="list-style">
                      <ng-container *ngFor="let sect of device.sectorizations">
                        <li class="mb-1 text-sm text-bold" >Type: {{ DeviceSectorization.getTypeByValue(sect.id) }}</li>
                        <li class="mb-1 text-sm" >Min Azimuth: {{sect.minangle}}</li>
                        <li class="mb-1 text-sm" >Max Azimuth: {{sect.maxangle}}</li>
                        <li class="mb-1 text-sm" >Range [NM]: {{sect.doc}}</li>
                      </ng-container>
                    </ul>
                  </ng-container>
                </ul>
              </ng-container>
            </div>
        </div>
      <pre *ngIf="calculationsService.calculationInfoIsString">
        {{calculationsService.calcInfoString}}
      </pre>
    </div>
  </div>
